export enum ContentType {
  None = 0,
  News = 1,
  Announcement = 2,
  Institutional = 3,
  Vision = 4,
  Mission = 5,
  Programs = 6
}

export enum DocumentType {
  None = 0,
  Image = 1,
  Word = 2,
  Excel = 3,
  Pdf = 4,
  Powerpoint = 5,
  Video = 6,
  Audio = 7,
  Zip = 8,
  Other = 9
}

export enum ContactType {
  None = 0,
  Callback = 1,
  Registration = 2,
  SuggestionRequest = 3,
  Complaint = 4,
  JobApplication = 5
}
